import React from 'react';
import { Heading, PropertyGroup } from '../../components';
import { languagesHelper as language } from '../../util/languages';
import { useIntl } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const SectionMultiEnumMaybe = props => {
  const { heading, options, selectedOptions, showUnselectedOptions = true, id } = props;
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }
  const idSlug = heading.toLowerCase().replace(/ /g, '_');
  const intl = useIntl();

  return (
    <section className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {id ? language.labelsTranslator(`pub_${id}`, intl) : heading}
      </Heading>
      <PropertyGroup
        id={`ListingPage.${idSlug}`}
        ariaLabel={heading}
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showUnselectedOptions={showUnselectedOptions}
        useTranslations
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;
